import ProfileLayout from './components/ProfileLayout';
import { paths } from '@/app/routes/paths';
import { ProfileIdentity, ProfileOrganization, ProfileViewProps } from './types';
import { useAuthStore } from '@/features/Auth/model/authStore';
import { useNavigate } from 'react-router-dom';

const ProfileView = (props: ProfileViewProps) => {
  const {
    clientMchd,
    isMchdLoading,
    isOrganizationLoading,
    isProfileLoading,
    organization,
    orgId,
    userProfile
  } = props;

  const navigate = useNavigate();

  const logout = useAuthStore((state) => state.logout);

  const apiUserName =
    `${userProfile?.last_name ?? ''} ${userProfile?.first_name ?? ''} ${userProfile?.middle_name ?? ''}`
      .trim();

  const profile: ProfileIdentity = {
    email: userProfile?.email ?? '',
    emailVerified: userProfile?.email_verified ?? true,
    name: apiUserName || 'Имя не указано'
  };

  const organizationView: ProfileOrganization | null = organization ? {
    id: organization.org_id,
    inn: organization.inn ?? '',
    kpp: organization.kpp ?? undefined,
    legalAddress: organization.address ?? undefined,
    name: organization.short_name ?? organization.full_name ?? '',
    ogrn: organization.ogrn ?? undefined
  } : null;

  return (
    <ProfileLayout
      hasOrganization={Boolean(orgId)}
      isMchdLoading={isMchdLoading}
      isOrganizationLoading={isOrganizationLoading}
      isProfileLoading={isProfileLoading}
      logout={logout}
      mchdItems={clientMchd?.items}
      mchdRequires={organization?.requires_mchd ?? false}
      mchdTotalCount={clientMchd?.total_count}
      navigate={navigate}
      orgId={orgId}
      onOpenOrganizationWarehouses={() => navigate(paths.profileWarehouses)}
      onOpenProfileEdit={() => navigate('/profile/edit')}
      organization={organizationView}
      profile={profile}
    />
  );
};

export default ProfileView;